import React from "react";
import {
  TextInput,
  SimpleForm,
  SelectInput,
  CreateProps,
  required,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid, Typography } from "@material-ui/core";
import CustomCreateToolbar from "components/CustomCreateToolbar";
import StudentInput from "./components/StudentInput";
import CustomDatePickerInput from "components/CustomDatePickerInput";
import { formTypeList } from "./conts";
import CreateWrapper from "../../components/CreateWrapper";

const ChangeRequestCreate = (props: CreateProps) => {
  const breadcrumb = [
    { title: "Change Request Forms", link: "/changeRequestForms" },
    { title: "Create", link: "/changeRequestForms/create" },
  ];

  return (
    <>
      <CreateWrapper
        breadcrumb={breadcrumb}
        headerTitle="New Change Request"
        isHaveSchoolFilter
        {...props}
      >
        <SimpleForm toolbar={<CustomCreateToolbar />}>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">Student</Typography>
            </Grid>

            <Grid item xs={4}>
              <StudentInput />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Change Request Detail</Typography>
            </Grid>

            <Grid item xs={4}>
              <CustomDatePickerInput name="wefDate" label="Wef Date *" />
            </Grid>
            <Grid item xs={4}>
              <CustomDatePickerInput name="endDate" label="End Date *" />
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <SelectInput
                choices={formTypeList}
                source="type"
                validate={required()}
              />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput multiline rows={3} source="description" />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <TextInput multiline rows={3} source="csDescription" />
            </Grid>
            <Grid item xs={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </CreateWrapper>
    </>
  );
};

export default ChangeRequestCreate;
